export const PREVIEW_HOST_MARKERS = ['lovableproject.com', 'id-preview--', 'id-preview--', 'preview--'];

export function isPreviewHost(hostname: string) {
  return PREVIEW_HOST_MARKERS.some((marker) => hostname.includes(marker));
}
